import { render, staticRenderFns } from "./addReportingCategory.vue?vue&type=template&id=828230b4&"
import script from "./addReportingCategory.vue?vue&type=script&lang=js&"
export * from "./addReportingCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports